import Vue from 'vue'

import MainTitle from '../components/design/MainTitle.vue'
import Subtitle from '../components/design/Subtitle.vue'
import InputHeadersGroup from '../components/design/InputHeadersGroup.vue'
import InputHeader from '../components/design/InputHeader.vue'
import TooltipIcon from '../components/design/TooltipIcon.vue'
import TooltipButton from '../components/design/TooltipButton.vue'

import ElFormErrors from '../components/element/ElFormErrors.vue'
import ElFormSmallItem from '../components/element/ElFormSmallItem.vue'
import ElFormSub from '../components/element/ElFormSub.vue'

import Comparator from '../components/comparator/Comparator.vue'
import Comparable from '../components/comparator/Comparable.vue'
import ComparatorFilter from '../components/comparator/ComparatorFilter.vue'

Vue.component(MainTitle.name, MainTitle)
Vue.component(Subtitle.name, Subtitle)
Vue.component(InputHeadersGroup.name, InputHeadersGroup)
Vue.component(InputHeader.name, InputHeader)
Vue.component(TooltipIcon.name, TooltipIcon)
Vue.component(TooltipButton.name, TooltipButton)

Vue.component(ElFormErrors.name, ElFormErrors)
Vue.component(ElFormSmallItem.name, ElFormSmallItem)
Vue.component(ElFormSub.name, ElFormSub)

Vue.component(Comparator.name, Comparator)
Vue.component(Comparable.name, Comparable)
Vue.component(ComparatorFilter.name, ComparatorFilter)
